import events from "../../constants/events";
import { dispatchEvent } from "../../utilities/customEvents";

import { Base } from "./Base";

export class OverlayTrigger extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.bindClickHandler();
  }

  bindClickHandler() {
    this.element.addEventListener("click", (e) => {
      e.preventDefault();
      this.openOverlay();
    });
  }

  openOverlay() {
    const options = {};

    options.target = this.element.href;

    if (this.element.dataset.titleText) {
      options.titleText = this.element.dataset.titleText;
    }

    if (this.element.dataset.subAnchor) {
      options.subAnchor = this.element.dataset.subAnchor;
    }

    if (this.element.dataset.linkUrl) {
      options.link = {
        url: this.element.dataset.linkUrl,
        text: this.element.dataset.linkText || "Read more",
      };
    }

    if (this.element.dataset.variants) {
      options.variants = this.element.dataset.variants;
    }

    dispatchEvent(window, events.OPEN_OVERLAY, options);
  }
}
